import Cookies from 'js-cookie'
import {getStore, setStore} from '@/utils/store'

const app = {
  state: {
    idCode: Cookies.get('pc_idCode') || 'all', // 应用id
    // 全局loading属性,放在layout上面
    loading: {
      yes: false,
      text: '拼命加载中',
      icon: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.6)'
    },
    mainDOMRect: {
      height: 0,
      width: 0
    }, // main区域高宽等属性
    protocol: window.location.protocol, // 协议名
    host: window.location.host, // 域名
    portalUrl: window.location.protocol + '//' + window.location.host, // 门户页面url
    projectName: 'AI 舌诊对接', // 项目左上角名称
    windowTitle: getStore({ // 浏览器标签名称
      name: 'windowTitle'
    }) || 'AI 舌诊对接',
    tagWel: getStore({ // 项目首页路径
      name: 'tagWel'
    }) || {
      label: '首页',
      value: '/dashboard'
    },
    imageBaseUrl: '', // 图片默认前缀
    sidebar: {
      opened: Number(Cookies.get('sidebarStatus')) === 1 || true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'zh', // 项目语言
    visLanguage: Cookies.get('visLanguage') || '0', // 可视化配置语言
    size: Cookies.get('size') || 'medium',
    // 项目主题颜色
    themeColor: Cookies.get('themeColor'),
    defaultUserPhoto: require('@/assets/images/user.png')
  },
  actions: {
    toggleSideBar ({commit}) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar ({commit}, {withoutAnimation}) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice ({commit}, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage ({commit}, language) {
      commit('SET_LANGUAGE', language)
    },
    setVisLanguage ({commit}, visLanguage) {
      commit('SET_VISLANGUAGE', visLanguage)
    },
    setSize ({commit}, size) {
      commit('SET_SIZE', size)
    },
    setMainDOMRect ({commit}, mainDOMRect) {
      commit('SET_MAIN_DOM_RECT', mainDOMRect)
    },
    setWindowTitle ({commit}, windowTitle) {
      commit('SET_WINDOWTITLE', windowTitle)
    },
    setIdCode ({commit}, idCode) {
      commit('SET_ID_CODE', idCode)
    }
  },
  mutations: {
    /*
     * 保存首页地址
     * @param state
     * @param routes
     * @constructor
     */
    SET_TAGWEL: (state, path) => {
      state.tagWel.value = path
      setStore({
        name: 'tagWel',
        content: state.tagWel
      })
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_VISLANGUAGE: (state, visLanguage) => {
      state.visLanguage = visLanguage
      Cookies.set('visLanguage', visLanguage)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },
    SET_THEME_COLOR: (state, color) => {
      state.themeColor = color
      Cookies.set('themeColor', color)
    },
    SET_MAIN_DOM_RECT: (state, mainDOMRect) => {
      state.mainDOMRect = mainDOMRect
    },
    SET_WINDOWTITLE: (state, windowTitle) => {
      state.windowTitle = windowTitle
      setStore({
        name: 'windowTitle',
        content: state.windowTitle
      })
    },
    SET_ID_CODE: (state, idCode) => {
      state.idCode = idCode
      Cookies.set('pc_idCode', idCode)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js